import { render, staticRenderFns } from "./multi_sn_rma.vue?vue&type=template&id=1757a36c&"
import script from "./multi_sn_rma.vue?vue&type=script&lang=js&"
export * from "./multi_sn_rma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports